import { BASE_PLAN_SUB_TYPES, enableProAnnualMonthlyPaymentPlan, enableProAnnualMonthlyPaymentPlanP2 } from '@/common/constants';
import { proAnnualMonthlyMarketingCampaignLimited } from '@/views/config/coupon/helper/utils';

/**
 * Check if we should filter out annual_term_monthly plans
 * @param {Object} context - Vue context object
 * @param {Array} boughtPlans - Array of bought plans
 * @param {Array} freeTrialPlans - Array of free trial plans
 * @returns {boolean} - Whether to filter out annual_term_monthly plans
 */
export function shouldFilterAnnualTermMonthly(context, boughtPlans, freeTrialPlans) {
  // Prerequisites: enableProAnnualMonthlyPaymentPlan = true AND enableProAnnualMonthlyPaymentPlanP2 = false
  if (!enableProAnnualMonthlyPaymentPlan || enableProAnnualMonthlyPaymentPlanP2) {
    return false;
  }

  // For add2cart or trial2paid context with specific bought plans
  if ((context.is.add2cart || context.is.trial2paid) &&
      boughtPlans.find(plan =>
        plan.category === BASE_PLAN_SUB_TYPES.ZOOM_ROOM ||
        (plan.category === BASE_PLAN_SUB_TYPES.PRO && plan.isFreeTrial)
      )) {
    return true;
  }

  // For marketing campaign limited or free trial plans with Zoom Room
  const freeTrialPlansHasZoomRoom = freeTrialPlans.find(p => p.category === BASE_PLAN_SUB_TYPES.ZOOM_ROOM);
  if (proAnnualMonthlyMarketingCampaignLimited() || freeTrialPlansHasZoomRoom) {
    return true;
  }

  return false;
}
